import { render } from "./CoverRequests.vue?vue&type=template&id=5f8bfbde&scoped=true"
import script from "./CoverRequests.vue?vue&type=script&lang=js"
export * from "./CoverRequests.vue?vue&type=script&lang=js"

import "./CoverRequests.vue?vue&type=style&index=0&id=5f8bfbde&scoped=true&lang=css"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8bfbde"]])

export default __exports__